const walk = (value: unknown, acc: string[]) => {
  if (value == null || value === '') return

  if (typeof value === 'string') {
    acc.push(value)
    return
  }

  if (Array.isArray(value)) {
    value.forEach((item) => walk(item, acc))
    return
  }

  if (typeof value === 'object') {
    Object.values(value).forEach((item) => walk(item, acc))
  }
}

export const collectApiErrorMessages = (...payloads: unknown[]): string[] => {
  const messages: string[] = []
  payloads.forEach((payload) => walk(payload, messages))
  return [...new Set(messages)]
}
